import PropTypes from 'prop-types';
import classnames from 'classnames';
import { getCardType } from '../../utils/helpers';
import styles from '../../styles/main.scss';

import PaymentDefaultCard from 'dibs-icons/exports/legacy/PaymentDefaultCard';
import PaymentVisa from 'dibs-icons/exports/legacy/PaymentVisa';
import PaymentMastercard from 'dibs-icons/exports/legacy/PaymentMastercard';
import PaymentDiscover from 'dibs-icons/exports/legacy/PaymentDiscover';
import PaymentAmericanExpress from 'dibs-icons/exports/legacy/PaymentAmericanExpress';

const creditCardIcons = {
    default: PaymentDefaultCard,
    visa: PaymentVisa,
    mastercard: PaymentMastercard,
    discover: PaymentDiscover,
    amex: PaymentAmericanExpress,
};

export const CardLogo = props => {
    const { validations = {}, disabled } = props;
    let cardType = getCardType(validations.maskedCardNumber) || props.cardType;
    if (!creditCardIcons[cardType] || disabled) {
        cardType = 'default';
    }
    const CardIcon = creditCardIcons[cardType];
    return (
        <CardIcon
            className={classnames(styles.cardIcon, {
                [styles.defaultCard]: cardType === 'default',
                [styles.disabled]: disabled,
            })}
        />
    );
};

CardLogo.propTypes = {
    cardType: PropTypes.string,
    validations: PropTypes.object,
    disabled: PropTypes.bool,
};
